var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.1665 11.25C3.1665 11.25 3.95817 10.5 6.33317 10.5C8.70817 10.5 10.2915 12 12.6665 12C15.0415 12 15.8332 11.25 15.8332 11.25V2.25C15.8332 2.25 15.0415 3 12.6665 3C10.2915 3 8.70817 1.5 6.33317 1.5C3.95817 1.5 3.1665 2.25 3.1665 2.25L3.1665 16.5",
    stroke: "#AFAFAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.4cffbc52b48f448df76f5a16e8c47389.svg";
export { ForwardRef as ReactComponent };